import { render, staticRenderFns } from "./alarm_center_backup.vue?vue&type=template&id=74629162"
import script from "./alarm_center_backup.vue?vue&type=script&lang=js"
export * from "./alarm_center_backup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports